import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <>
        <div className="header">
          <div className="header-bottomarea">
            <div className="container">
              <div className="header-bottominner" style={{ height: '5rem' }}>
                <div className="header-logo">
                  <a href={`${process.env.REACT_APP_ORGANIZATION}`}>
                    <img
                      src={require('../../images/drapcode-logo-bluegreen.png')}
                      style={{ maxHeight: '45px' }}
                      alt="DrapCode Logo"
                      loading="lazy"
                    />
                  </a>
                </div>
                <nav className="tm-navigation d-block"></nav>
              </div>
            </div>
          </div>
        </div>
        <main>
          <section className="section">
            <div className="container py-5 my-3">
              <div className="row">
                <div className="col-md-2 text-center">
                  <p>
                    <i
                      className="wb webconnect-exclamation-triangle-fill"
                      style={{ fontSize: '5em', color: '#718096' }}
                    ></i>
                    <br />
                    Status Code: 404
                  </p>
                </div>
                <div className="col-md-10">
                  <h3>OPPSSS!!!! Sorry...</h3>
                  <p>Page Not Found</p>
                  <a href={`${process.env.REACT_APP_ORGANIZATION}`} className="btn btn-danger">
                    Go Back
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
